const resetRvValidations = () => ({ type: 'RESET_RV_VALIDATIONS' })

const updateHasValidations = hasValidations => ({ type: 'UPDATE_HAS_VALIDATIONS', payload: hasValidations })

const updateRvValidations = data => ({ type: 'UPDATE_RV_VALIDATIONS', payload: data })

export { resetRvValidations, updateHasValidations, updateRvValidations }
